<div bsModal #addConfigModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" (onHide)="onHideModal($event)">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="abortAddConfig(addConfigModal)" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" *ngIf="mode==='add'">Add Store Report Config</h4>
                <h4 class="modal-title" *ngIf="mode==='edit'">Edit Store Report Config</h4>
                <h4 class="modal-title" *ngIf="mode==='auto'">Report Settings</h4>
            </div>
            <div *ngIf="visible">
                <form class="form-horizontal" [formGroup]="form" (ngSubmit)="onSubmit(addConfigModal)">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <p class="text-muted">
                                    Configure the daily automated store settlement report email for this company. When enabled, the system automatically sends each day's store transaction summary report to the recipients below after settlement completes.
                                </p>
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <label class="control-label">Company:</label>
                                        <p class="form-control-static">{{ companyService.companyData?.xName }}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <label for="recipientEmails" class="control-label">Recipient Emails:
                                        <small class="text-danger">*</small>
                                        </label>
                                        <small *ngIf="incorrectMailFormat" class="inline-error">
                                            <i class="fa fa-exclamation-triangle inline-error" tooltip="Email format is not valid" placement="top" container="body" containerClass="tooltip-custom inline-error" aria-hidden="true"></i>
                                        </small>
                                        <small *ngIf="!incorrectMailFormat && form.get('xRecipientEmails').hasError('required') && form.get('xRecipientEmails').touched" class="inline-error">
                                            <i class="fa fa-exclamation-triangle inline-error" tooltip="At least one recipient email is required" placement="top" container="body" containerClass="tooltip-custom inline-error" aria-hidden="true"></i>
                                        </small>
                                        <tag-input
                                            id="recipientEmails"
                                            formControlName="xRecipientEmails"
                                            [addOnBlur]="true"
                                            [separatorKeyCodes]="[32]"
                                            [ngClass]="{ 'has-error': incorrectMailFormat }"
                                            placeholder="Add Email Ids"
                                            secondaryPlaceholder="Add Email Ids"
                                            [editable]="true"
                                            (onAdd)="onItemAddedEditedOrRemoved($event)"
                                            (onRemove)="onItemAddedEditedOrRemoved($event)"
                                            (onTagEdited)="onItemEdited($event)"
                                        ></tag-input>
                                    </div>
                                </div>
                                <div class="form-group row no-margin">
                                    <div class="col-sm-12">
                                        <label class="checkbox-wrap">
                                            <label class="checkbox1" for="enabled">
                                                <input id="enabled" type="checkbox" formControlName="xEnabled" />
                                                <span></span>
                                            </label>
                                            <span class="text">Enabled</span>
                                            <i
                                                class="fa fa-info-circle m-l-5"
                                                tooltip="Turning this off pauses daily automatic sending but keeps your saved recipient list. Turning it back on resumes sending from the next settlement cycle."
                                                placement="top"
                                                containerClass="tooltip-global"
                                                container="body"
                                                aria-hidden="true"
                                            ></i>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a class="btn btn-secondary" (click)="abortAddConfig(addConfigModal)"><i class="fa fa-times" aria-hidden="true"></i> Cancel</a>
                        <button class="btn btn-primary" [disabled]="!form.valid || incorrectMailFormat"><span>Save <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></button>
                    </div>
                </form>
            </div>
            <div *ngIf="!visible">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12" style="text-align: center;">
                            <div class="grid-spinner">
                                <div class="bounce1"></div>
                                <div class="bounce2"></div>
                                <div class="bounce3"></div>
                            </div>
                            <span style="color:#3b5877">Fetching required data</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <a class="btn btn-sm btn-secondary" (click)="abortAddConfig(addConfigModal)">
                        <i class="fa fa-times" aria-hidden="true"></i> Cancel
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
